import React from 'react';

import createReactClass from 'create-react-class';
import MediaBrowser from './MediaBrowser.jsx';
import MediaBrowserService from './MediaBrowserService.jsx';

var MediaBrowserPopup = createReactClass({
  closeMediaBrowserPopup: function() {
    MediaBrowserService.closeMediaBrowser();
  },
  render: function() {
    return (
      <div
        className="cm"
        style={{
          position: 'fixed',
          width: '100%',
          height: '100%',
          top: '0',
          left: '0',
          backgroundColor: 'rgba(0, 0, 0, 0.75)',
          zIndex: '5',
        }}
      >
        <div
          style={{
            border: '1px solid #222',
            height: '90%',
            margin: '2% 5%',
            position: 'absolute',
            width: '90%',
          }}
        >
          <div className="mb-popup-header">
            <span>Media Browser</span>
            <div
              onClick={this.closeMediaBrowserPopup}
              className="close-button"
            />
          </div>
          <div className="mb-popup-body">
            <MediaBrowser
              onFileSelect={this.props.onFileSelect}
              mediaManager={this.props.mediaManager}
              multipleSelect={this.props.multipleSelect}
            />
          </div>
        </div>
      </div>
    );
  },
});

export default MediaBrowserPopup;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/mediaBrowser/MediaBrowserPopup.jsx